/**
 * Created by LIDA1FH on 05/11/2016.
 */
module.exports = function(bootstrap) {
    bootstrap.run(['$rootScope', function($rootScope) {
        $rootScope.sidebar = {};
    }]);

    bootstrap.directive('clientSideBarOnePage', ["$location", function($location) {
        return {
            replace: true,
            template: require('directives/hmhs/clientSideBarOnePage.html'),

            link: function(scope, element) {
                scope.scrollTo = function (hash) {
                    $location.hash(hash);
                };

            }
        }
    }])
}